import React, { useEffect, useRef } from 'react';
import './KodanshaHeader.scss';
import { useHistory } from 'react-router-dom';
import { Link } from '../../Devon/Components/InkyLink';
import { useAtom } from 'jotai';
import { fetchHero } from '../../store/HeroStore';
import { KodanshaColors } from '../../utils/constants';
import { SrcSet } from '../../Components/SrcSet/SrcSet';
import InkyMageImg from '../../Devon/Components/InkyMageImg/InkyMageImg';

const tags = ['horror', 'science fiction', 'genre tag'];

const KodanshaHeader = (props): JSX.Element => {
    const history = useHistory();
    const color = useRef('rgb(20, 191, 161)');
    const [data, fetch] = props.test ? [props.test, () => {
        console.log('test');
    }] : useAtom(fetchHero);
    // const data = null;
    useEffect(() => {
        fetch();
    }, []);
    console.log('props.test', data);

    if (!data) {
        return <header className='header-signin-container'>
            <div className='header-container'>
                <div className='poster-wrapper'>
                    <div className='poster' />
                    <div className='colorize' />
                </div>
            </div>
        </header>;
    }


    return (
        <header className='header-signin-container'>
            <div className='header-container'>

                <div className='poster-wrapper' onClick={(): void => {
                    if (data.readableUrl) {
                        history.push('/series/' + data.readableUrl);
                    } else if (data.externalLink) {
                        window.open(data.externalLink, '_blank');
                    }
                    // history.push(data.readableUrl ? '/series/' + data.readableUrl : data.externalLink);
                }}>
                    <div className={`poster ${data.colorOverlay === 'grayscale' ? 'poster-filter' : ''}`}>
                        {/*<SrcSet imageUrl={data.imageUrl} alt={'Hero banner'} colSize={24} />*/}


                        <InkyMageImg className='ui-series-poster-image'
                                     src={data.imageUrl}
                                     alt={'Hero Banner'}
                                     preloadImage={true}
                                     s={{width: 992}}
                                     m={{width: 992}}
                                     l={{width: 992}}
                                     xl={{width: 1440}}
                                     width={1440}
                                     height={900}
                        />
                    </div>
                    <div className='colorize'
                         style={{
                             backgroundColor: KodanshaColors[data.colorOverlay],
                         }} />
                </div>

                <div className='header-max-wrapper'>
                    <div className='header-info-wrapper'>
                        <h2 aria-label={data.kicker}
                            className='description'>
                            {data.kicker}
                        </h2>
                        <h1 aria-label={data.title} className='title'>
                            {data.title}
                        </h1>

                        <div className='tags-container'>
                            {tags.map(tag => <span aria-label={'tag ' + tag} key={tag} className='tag'>
                            {tag}
                        </span>)}
                        </div>


                        <div className='actions-wrapper'>
                            {/*{width >= 768 &&*/}
                            <span
                                aria-label={data.author}
                                className='actions-wrapper-author-name'>{data.author}</span>
                            {/*}*/}

                            <Link target={data.readableUrl ? '_self' : '_blank'}
                                  to={{ pathname: data.readableUrl ? '/series/' + data.readableUrl : data.externalLink }}
                                  onClick={e => e.stopPropagation()}>
                                <span className={'submit'}>
                                    {data.buttonText ?? 'View More Info'}
                                </span>
                                {/*<KodanshaSubmit text='View More Info' onSubmitClicked={() => {*/}
                                {/**/}
                                {/*}} />*/}
                            </Link>

                            {/*<div className='detail-buy-wrapper'>*/}
                            {/* TODO: Kodensha Beta */}
                            {/*<span className='detail-buy detail'>DETAILS</span>*/}
                            {/*<span className='detail-buy'>BUY</span>*/}
                            {/*<span className='detail-buy wishlist'>WISHLIST</span>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>


        </header>
    );
};

export default React.memo(KodanshaHeader);
